// extracted by mini-css-extract-plugin
export default {"headerText":"styles_headerText__b5aXe","animtext":"styles_animtext__k52ht"};